import { makeStyles, Theme } from '@material-ui/core';

export interface StyleProps {
  expanded: boolean;
}

const GAP_SIZE = 10;
const EXPANDED_NB_COLUMNS = 2;
const CLOSED_NB_COLUMNS = 3;

export const useStyles = makeStyles<Theme, StyleProps>(() => {
  return {
    loadingContainer: {
      height: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    linearProgress: {
      width: '60%',
    },
    categoryContainer: ({ expanded }: StyleProps) => ({
      padding: 10,
      display: 'flex',
      flexDirection: 'column',
      alignContent: 'flex-start',
      justifyContent: 'start',
      height: '100vh',
      flexWrap: 'wrap',
      gap: GAP_SIZE,
      overflow: 'scroll',
      '& > div': {
        width: `calc(${100 /
          (expanded ? EXPANDED_NB_COLUMNS : CLOSED_NB_COLUMNS)}% - ${GAP_SIZE}px)`,
      },
    }),
  };
});
